import React from 'react';

/**
 * Full-screen wrapper for onboarding screens. No header/footer.
 * Centered content, RTL-friendly, rounded card with soft shadow.
 */
const OnboardingLayout = ({ children }) => {
  return (
    <div
      className="min-h-screen flex items-center justify-center p-4 md:p-6 bg-gradient-to-b from-slate-50 to-white"
      dir="rtl"
    >
      <div className="w-full max-w-md rounded-2xl bg-white shadow-lg p-6 md:p-8">
        {children}
      </div>
    </div>
  );
};

export default OnboardingLayout;
